var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJupyter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.265 24.136c-5.068 0-9.599-1.871-12-4.537 0.932 2.401 2.537 4.537 4.667 6 2.136 1.469 4.667 2.265 7.333 2.265s5.204-0.796 7.333-2.265c2.136-1.463 3.735-3.599 4.667-6-2.401 2.667-6.932 4.537-12 4.537zM16.265 6.531c5.068 0 9.599 1.871 12 4.537-0.932-2.401-2.531-4.537-4.667-6-2.265-1.599-4.796-2.401-7.333-2.401-2.667 0-5.197 0.803-7.333 2.265-2.129 1.599-3.735 3.599-4.667 6.136 2.401-2.803 6.803-4.537 12-4.537zM25.599 0.136c-2.489 0-2.489 3.728 0 3.728s2.489-3.728 0-3.728zM6.803 27.068c-1.329 0-2.401 1.072-2.401 2.401 0 1.323 1.072 2.395 2.401 2.395 1.323 0 2.395-1.072 2.395-2.395 0-1.329-1.072-2.401-2.395-2.401zM4.803 3.068c-1.781 0-1.781 2.667 0 2.667 1.776 0 1.776-2.667 0-2.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupyter);
export default __webpack_public_path__ + "static/media/jupyter.639ee2e8cc5f0e6bc89fdc04c23ac7bc.svg";
export { ForwardRef as ReactComponent };